import HundredBricksAPIError from '../../../HundredBricksAPIError';
class CrowdfundingPropertyError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('CrowdfundingPropertyError', ...args);
    }
}
export default CrowdfundingPropertyError;
